import { apiSlice } from "../../../app/services/authServices";

export const companyProfileApiSlice = apiSlice.injectEndpoints({
    tagTypes: ["CompanyProfile"],
    endpoints: builder => ({
        createCompanyProfile: builder.mutation({
            query: (DTO) => ({
                url: 'CompanyProfile/CreateCompanyProfile',
                method: 'POST',
                body: DTO,
            }),
            invalidatesTags: [{ type: "CompanyProfile", id: "LIST" }],
        }),
        updateCompanyProfile: builder.mutation({
            query: ({ DTO, CompanyProfileID }) => ({
                url: `CompanyProfile/UpdateCompanyProfile?CompanyProfileID=${CompanyProfileID}`,
                method: 'POST',
                body: DTO,
            }),
            // Invalidate both the specific profile and the list
            invalidatesTags: (result, error, { CompanyProfileID }) => [
                { type: "CompanyProfile", id: CompanyProfileID },
                { type: "CompanyProfile", id: "LIST" },
            ],
        }),
        getAllCompanyProfiles: builder.query({
            query: () => ({
                url: 'CompanyProfile/GetListofCompanyProfiles',
                method: 'GET',
            }),
            providesTags: (result) =>
                result
                    ? [
                        ...result.data.map(({ companyProfileID }) => ({
                            type: "CompanyProfile",
                            id: companyProfileID,
                        })),
                        { type: "CompanyProfile", id: "LIST" },
                    ]
                    : [{ type: "CompanyProfile", id: "LIST" }],
        }),
        getCompanyProfileById: builder.query({
            query: (CompanyProfileID) => ({
                url: `CompanyProfile/GetCompanyProfileById?CompanyProfileID=${CompanyProfileID}`,
                method: 'GET',
            }),
            providesTags: (result, error, CompanyProfileID) => [
                { type: "CompanyProfile", id: CompanyProfileID },
            ],
        }),
        deleteCompanyProfile: builder.mutation({
            query: (CompanyProfileID) => ({
                url: `CompanyProfile/DeleteCompanyProfile?CompanyProfileID=${CompanyProfileID}`,
                method: 'POST',
            }),
            invalidatesTags: [{ type: "CompanyProfile", id: "LIST" }]
        }),
        addCompanyDock: builder.mutation({
            query: (body) => ({
                url: 'CompanyProfile/AddDock',
                method: 'POST',
                body,
            }),
            invalidatesTags: (result, error, { CompanyProfileID }) => [
                { type: "CompanyProfile", id: CompanyProfileID },
            ],
        }),
        editCompanyDock: builder.mutation({
            query: (body) => ({
                url: 'CompanyProfile/EditDock',
                method: 'POST',
                body,
            }),
            invalidatesTags: (result, error, { CompanyProfileID }) => [
                { type: "CompanyProfile", id: CompanyProfileID },
            ],
        }),
        deleteCompanyDock: builder.mutation({
            query: ({ DockId }) => ({
                url: `CompanyProfile/DeleteDock?DockId=${DockId}`,
                method: 'POST',
            }),
            invalidatesTags: (result, error, { CompanyProfileID }) => [
                { type: "CompanyProfile", id: CompanyProfileID },
            ],
        }),
    }),
});

export const {
    useGetCompanyProfileByIdQuery,
    useAddCompanyDockMutation,
    useEditCompanyDockMutation,
    useDeleteCompanyDockMutation,
    useDeleteCompanyProfileMutation,
    useUpdateCompanyProfileMutation,
    useLazyGetCompanyProfileByIdQuery,
    useCreateCompanyProfileMutation,
    useGetAllCompanyProfilesQuery
} = companyProfileApiSlice;
